// custom hover intent
/* document.querySelectorAll('.list-menu--megamenu').forEach((menuItem) => {
  const megaMenu = menuItem.querySelector('.mega-menu');
  let hoverTimer;

  menuItem.addEventListener('mouseenter', () => {
    hoverTimer = setTimeout(() => {
      megaMenu.classList.add('visible');
    }, 100); // delay for hover intent
  });

  menuItem.addEventListener('mouseleave', () => {
    clearTimeout(hoverTimer);
    megaMenu.classList.remove('visible');
  });
}); */

// Lazy-load mega menu images when the menu becomes visible
(() => {
  const VISIBLE_CLASS = "list-menu--megamenu-visible"; // change if your visible class is different

  const loadMenuImages = (menuEl) => {
    const imgs = menuEl.querySelectorAll("img[data-src]");
    imgs.forEach((img) => {
      const src = img.getAttribute("data-src");
      if (!src) return;

      // Prevent double work
      img.setAttribute("src", src);
      img.removeAttribute("data-src");
    });
  };

  const observeMenu = (menuEl) => {
    // If already visible, load immediately
    if (menuEl.classList.contains(VISIBLE_CLASS)) loadMenuImages(menuEl);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "attributes" || m.attributeName !== "class") continue;

        if (menuEl.classList.contains(VISIBLE_CLASS)) {
          loadMenuImages(menuEl);
        }
      }
    });

    observer.observe(menuEl, {
      attributes: true,
      attributeFilter: ["class"],
    });
  };

  const init = () => {
    document.querySelectorAll(".mega-menu, .list-menu--megamenu").forEach(observeMenu);
  };

  // Run now
  init();

  // Re-run when Shopify loads/reloads sections in theme editor
  document.addEventListener("shopify:section:load", init);
})();